mainApp.directive('ipsecPrivateIps', function() {
    return {
        templateUrl: '/public/directives/ipsecPrivateIps.html',
        scope: {
             privateIps: '=',
             siteIpPath: '@',
             catoIpPath: '@'
        }
    }
});